import { React, useState, useEffect, Fragment } from 'react'
import {PostData} from '../Services/httpHandelars'
import UserRegistration from '../Components/UserRegistration'
import { useGlobalContext } from '../context'
import { useNavigate } from 'react-router-dom';
import Snackbar from '../Components/Snackbar';
import Pagination from '../Components/Pagination';
import DeactivateUserModal from '../Components/DeactivateUserModal';

export default function UserManagement  () {


  const navigate = useNavigate();

  const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" });
  useEffect(
    () => {
      if (snacBar.snacStatus === true) {
        setTimeout(() => setSnacBar(false), 3000);
      }
    },

    [snacBar.snacStatus]
    );

    
    const [open, setOpen] = useState(false);
    //const [openDeactivate, setOpenDeactivate] = useState(false);
    const [openDeactivate, setOpenDeactivate] = useState({modalStatus: false, modalButton: "No"});
    const [users, setUsers] = useState([]);
    const [ID, setID] = useState("");
    const [deactivateID, setDeactivateID] = useState("");

    
    const [data, setdata] = useState({});
    const { newUser , setUser} = useGlobalContext();

    
    useEffect(() => {
      if(openDeactivate.modalStatus === false && openDeactivate.modalButton === "Yes"){
        PostData("/api/user/getUserData").then((success) => {
          const user = success.results.UserData
          setUsers(user)
        })
      }
    },[openDeactivate])
    
    useEffect(() => {
      const body = {
        skip: 0,
        limit: 25
      }
      
      PostData("/api/user/getUserData", body).then((data) => {
        if(!data.status && data.message === "jwt expired"){
          setUser(null)
          navigate('/')
        }
        
        const user = data?.results?.UserData;
        setUsers(user)
        setdata(data)
        
        
      }).catch(e => console.log(e))
    },[])
    
    const handlePageChange = (body) => {
      let data = {
        skip : body.skip,
        limit : body.limit
      };
      PostData("/api/user/getUserData", data).then((data) => {
        
        console.log(data)
        if(!data.status && data.message === "jwt expired"){
          setUser(null)
          navigate('/Lagin')
        }
        
        let usersData = data.results.UserData;
        
        
        setUsers(usersData)
        
      }).catch(e => console.log(e))
    }
    

    useEffect(() => {
      setUsers([...users, newUser])
      if(newUser.EmailID){
        setSnacBar({
          ...snacBar,
          snacStatus: true,
          message: "User created Successfully",
          snackType: "Success"
        })
      }

  },[newUser])

  const handleDeactivate = (_id) => {
    setDeactivateID(_id)
    setOpenDeactivate({...openDeactivate, modalStatus: true})
  }

  const handleEditUser = (id) => {
   setID(id);
   setOpen(true)
  }

  const openModal = () => {
    setOpen(true)
  }

  return (
    <>
    <div className='grid justify-center'>
      <div className='grid justify-end'>
        <button onClick={openModal} type='submit' className='group mt-20 py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'>User Registration</button>
        <UserRegistration open={open} setOpen={setOpen} ID={ID} setID={setID} users={users} setUsers={setUsers}/>
      </div>
      <div className='grid-cols-1'>
        <table className="text-sm text-center text-gray-500 dark:text-gray-400 mt-20">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                First Name
              </th>
              <th scope="col" className="py-3 px-6">
                Last Name
              </th>
              <th scope="col" className="py-3 px-6">
                Email Address
              </th>
              <th scope="col" className="py-3 px-6">
                Login ID
              </th>
              <th scope="col" className="py-3 px-6">
                Contact
              </th>
              <th scope="col" className="py-3 px-6">
                Rights
              </th>
              <th scope="col" className="py-3 px-6">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {
              users?.map(user => (
                  <tr key={user?._id} className="bg-white border-b dark:border-gray-700 text-gray-700 font-medium h-12">
                    <td className='px-6'>{user?.FirstName}</td>
                    <td className='px-6'>{user?.LastName}</td>
                    <td className='px-6'>{user?.EmailID}</td>
                    <td className='px-7'>{user?.LoginID}</td>
                    <td className='px-6'>{user?.ContactNumber}</td>
                    <td className='px-6'>{user?.Role}</td>
                    <td className='px-4'>
                      <button onClick={() =>handleEditUser(user._id)} className='mr-2 group py-1 px-3 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'>Edit</button>
                      <button onClick={() =>handleDeactivate(user._id)} className='group  py-1 px-3 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'>Deactivate</button>
                    </td>
                  </tr>
              ))
            }
          </tbody>
        </table>
            <DeactivateUserModal openDeactivate={openDeactivate.modalStatus} setOpenDeactivate={setOpenDeactivate} id={deactivateID} />
        <Pagination handlePageChange={handlePageChange} total={data?.results?.totalCount} page={Math.ceil(data?.results?.totalCount / 25)}/>
      </div>
    </div>
    {snacBar?.snacStatus &&
                <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar}/>
    }
    </>
  )

  }